import {AnketaModule} from '../core/interface/anketa.interface';

export  const anketaData:AnketaModule[]= [
  {
    moduleNumber:1,
    data:[
      {
      title:'1. Регион проживания.',
      type:'select',
      controlName: 'module-1-q-1',
      required:true,
      selectedModule:'',
      options:[],
        placeholder:'Выбрать из списка'
    },
      {
        title:'2. Город / населённый пункт проживания.',
        type:'input',
        controlName: 'module-1-q-2',
        required:true,
      },
      {
        title:'3.Образование:',
        type:'radio',
        options:[
          {
            id: 'module-1-q-3-a',
            controlName: 'module-1-q-3',
            required:true,
            value: 'магистратура / специалитет',
            label: 'магистратура / специалитет,'
          },
          {
            id: 'module-1-q-3-b',
            controlName: 'module-1-q-3',
            required:true,
            value: 'бакалавриат',
            label: 'бакалавриат,'
          },
          {
            id: 'module-1-q-3-c',
            controlName: 'module-1-q-3',
            required:true,
            value: 'среднее-профессиональное',
            label: 'среднее-профессиональное,'
          },
          {
            id: 'module-1-q-3-d',
            controlName: 'module-1-q-3',
            required:true,
            value: 'общее образование (школа)',
            label: 'общее образование (школа).'
          },
        ]
      },
      {
        title:'4.Укажите род занятий, место работы до начала службы на СВО.',
        type:'textarea',
        controlName:'module-1-q-4',
        required:true,
      },
      {
        title:'5. Ваш вид деятельности в настоящее время:',
        type:'radio',
        options:[
          {
            id: 'module-1-q-5-a',
            controlName: 'module-1-q-5',
            required:true,
            value: 'работаю',
            label: 'работаю,'
          },
          {
            id: 'module-1-q-5-b',
            controlName: 'module-1-q-5',
            required:true,
            value: 'учусь',
            label: 'учусь,'
          },
          {
            id: 'module-1-q-5-c',
            controlName: 'module-1-q-5',
            required:true,
            value: 'прохожу реабилитацию',
            label: 'прохожу реабилитацию,'
          },
        ]
      },
      {
        title:'6. В какой период Вы участвовали в СВО? Укажите даты (месяц и год) начала и окончания. .',
        type:'textarea',
        controlName:'module-1-q-6',
        required:true,
      },
      {
        title:'7. Отметьте, что к Вам относится из нижеперечисленного:',
        type:'radio',
        options:[
          {
            id: 'module-1-q-7-a',
            controlName: 'module-1-q-7',
            required:true,
            value: 'контрактник',
            label: 'контрактник,'
          },
          {
            id: 'module-1-q-7-b',
            controlName: 'module-1-q-7',
            required:true,
            value: 'доброволец',
            label: 'доброволец,'
          },
          {
            id: 'module-1-q-7-c',
            controlName: 'module-1-q-7',
            required:true,
            value: 'мобилизованный',
            label: 'мобилизованный,'
          },
        ]
      },
      {
        title:'8. Укажите, какие ранения были получены во время участия в СВО',
        type:'radio-select',
        options:[
          {
            id: 'module-1-q-8-a',
            controlName: 'module-1-q-8',
            required:true,
            type:'radio',
            value: 'минно-взрывные ранения',
            label: 'минно-взрывные ранения,'
          },
          {
            id: 'module-1-q-8-b',
            controlName: 'module-1-q-8',
            required:true,
            type:'radio',
            value: 'осколочные ранения',
            label: 'осколочные ранения'
          },
          {
            id: 'module-1-q-8-c',
            controlName: 'module-1-q-8',
            required:true,
            type:'radio',
            value: 'контузия/баротравма/сотрясение',
            label: 'контузия/баротравма/сотрясение,'
          },
          {
            id: 'module-1-q-8-d',
            controlName: 'module-1-q-8',
            required:true,
            type:'radio',
            value: 'переломы',
            label: 'переломы,'
          },
          {
            id: 'module-1-q-8-e',
            controlName: 'module-1-q-8',
            required:true,
            type:'radio',
            value: 'ампутации и отрывы конечностей',
            label: 'ампутации и отрывы конечностей,'
          },
          {
            id: 'module-1-q-8-f',
            controlName: 'module-1-q-8',
            required:true,
            type:'radio',
            value: 'черепно‑мозговая травма',
            label: 'черепно‑мозговая травма,'
          },
          {
            id: 'module-1-q-8-g',
            controlName: 'module-1-q-8',
            required:true,
            value: 'не получил никаких ранений',
            type:'radio',
            label: 'не получил никаких ранений,'
          },
          {
            id: 'module-1-q-8-h',
            controlName: 'module-1-q-8',
            required:true,
            value: 'other',
            type:'radio',
            label: 'Другое'
          },
          {
            id:'module-1-q-8-j',
            controlName:'module-1-q-8-textarea',
            required:true,
            value:'',
            type:'textarea',
            placeholder:'Введите текст',
            label: 'Другое'
          },

        ]
      },
      {
        title:'9. Готовы ли Вы к публичному освещению Вашей деятельности как ветерана СВО (участие в теле- и радиопередачах, интернет-проектах)?',
        type:'radio',
        options:[
          {
            id: 'module-1-q-9-a',
            controlName: 'module-1-q-9',
            required:true,
            value: 'готов',
            label: 'готов,'
          },
          {
            id: 'module-1-q-9-b',
            controlName: 'module-1-q-9',
            required:true,
            value: 'не готов',
            label: 'не готов.'
          },
        ]
      },
      {
        title:'10. Был ли у Вас опыт общественной деятельности:',
        type:'radio',
        options:[
          {
            id: 'module-1-q-10-a',
            controlName: 'module-1-q-10',
            required:true,
            value: 'да',
            label: 'да,'
          },
          {
            id: 'module-1-q-10-b',
            controlName: 'module-1-q-10',
            required:true,
            value: 'нет',
            label: 'нет.'
          },

        ]
      },
      {
        title:'11. Если был опыт общественной деятельности, коротко расскажите о нём.',
        controlName:'module-1-q-11',
        required:true,
        type:'textarea',
        placeholder:'Введите текст',
      },
      {
        title:'12. Готовы ли Вы делиться личным опытом, поддерживать и помогать другим участникам СВО?',
        type:'radio',
        options:[
          {
            id: 'module-1-q-12-a',
            controlName: 'module-1-q-12',
            required:true,
            value: 'да',
            label: 'да,'
          },
          {
            id: 'module-1-q-12-b',
            controlName: 'module-1-q-12',
            required:true,
            value: 'нет',
            label: 'нет,'
          },
          {
            id: 'module-1-q-12-c',
            controlName: 'module-1-q-12',
            required:true,
            value: 'не знаю',
            label: 'не знаю.'
          },
        ]
      },
      {
        title:'13. Отметьте все, что к Вам относится из нижеперечисленного:',
        type:'radio',
        options:[
          {
            id: 'module-1-q-13-a',
            controlName: 'module-1-q-13',
            required:true,
            value: 'состою в стабильных отношениях',
            label: 'состою в стабильных отношениях,'
          },
          {
            id: 'module-1-q-13-b',
            controlName: 'module-1-q-13',
            required:true,
            value: 'женат',
            label: 'женат,'
          },
          {
            id: 'module-1-q-13-c',
            controlName: 'module-1-q-13',
            required:true,
            value: 'разведен',
            label: 'разведен,'
          },
          {
            id: 'module-1-q-13-d',
            controlName: 'module-1-q-13',
            required:true,
            value: 'вдовец',
            label: 'вдовец,'
          },
          {
            id: 'module-1-q-13-e',
            controlName: 'module-1-q-13',
            required:true,
            value: 'расстались, но не разведены',
            label: 'расстались, но не разведены,'
          },
          {
            id: 'module-1-q-13-f',
            controlName: 'module-1-q-13',
            required:true,
            value: 'холост',
            label: 'холост.'
          },
        ]
      },
      {
        title:'14. Есть ли у Вас ребёнок/дети:',
        type:'radio',
        options:[
          {
            id: 'module-1-q-14-a',
            controlName: 'module-1-q-14',
            required:true,
            value: 'да',
            label: 'да,'
          },
          {
            id: 'module-1-q-14-b',
            controlName: 'module-1-q-14',
            required:true,
            value: 'нет',
            label: 'нет.'
          },

        ]
      }
    ]
  },
  {
    moduleNumber:2,
    titleModule:'В какой степени Вы согласны со следующими утверждениями?',
    data:[
      {
        title:'1. Я верю, что смогу реализовать свои цели на ближайшие 5 лет.',
        type:'radio',
        options:[
          {
            id: 'module-2-q-1-a',
            controlName: 'module-2-q-1',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-2-q-1-b',
            controlName: 'module-2-q-1',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-2-q-1-c',
            controlName: 'module-2-q-1',
            required:true,
            value: 'в чем-то согласен, в чем-то нет',
            label: 'в чем-то согласен, в чем-то нет'
          },
          {
            id: 'module-2-q-1-d',
            controlName: 'module-2-q-1',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-2-q-1-e',
            controlName: 'module-2-q-1',
            required:true,
            value: 'абсолютно согласен',
            label: 'абсолютно согласен'
          },
        ]
      },
      {
        title:'2. Лучше жить сегодняшним днем, не заглядывая далеко в будущее.',
        type:'radio',
        options:[
          {
            id: 'module-2-q-2-a',
            controlName: 'module-2-q-2',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-2-q-2-b',
            controlName: 'module-2-q-2',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-2-q-2-c',
            controlName: 'module-2-q-2',
            required:true,
            value: 'в чем-то согласен, в чем-то нет',
            label: 'в чем-то согласен, в чем-то нет'
          },
          {
            id: 'module-2-q-2-d',
            controlName: 'module-2-q-2',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-2-q-2-e',
            controlName: 'module-2-q-2',
            required:true,
            value: 'абсолютно согласен',
            label: 'абсолютно согласен'
          },
        ]
      },
      {
        title:'3. Я верю, что в будущем у меня появится больше планов и желаний, чем было в прошлом.',
        type:'radio',
        options:[
          {
            id: 'module-2-q-3-a',
            controlName: 'module-2-q-3',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-2-q-3-b',
            controlName: 'module-2-q-3',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-2-q-3-c',
            controlName: 'module-2-q-3',
            required:true,
            value: 'в чем-то согласен, в чем-то нет',
            label: 'в чем-то согласен, в чем-то нет'
          },
          {
            id: 'module-2-q-3-d',
            controlName: 'module-2-q-3',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-2-q-3-e',
            controlName: 'module-2-q-3',
            required:true,
            value: 'абсолютно согласен',
            label: 'абсолютно согласен'
          },
        ]
      },
      {
        title:'4. Я думаю, что мое будущее больше зависит от внешних обстоятельств, чем от меня самого.',
        type:'radio',
        options:[
          {
            id: 'module-2-q-4-a',
            controlName: 'module-2-q-4',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-2-q-4-b',
            controlName: 'module-2-q-4',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-2-q-4-c',
            controlName: 'module-2-q-4',
            required:true,
            value: 'в чем-то согласен, в чем-то нет',
            label: 'в чем-то согласен, в чем-то нет'
          },
          {
            id: 'module-2-q-4-d',
            controlName: 'module-2-q-4',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-2-q-4-e',
            controlName: 'module-2-q-4',
            required:true,
            value: 'абсолютно согласен',
            label: 'абсолютно согласен'
          },
        ]
      },
      {
        title:'5. Многим моим друзьям и знакомым в наше время будущее представляется слишком неопределенным',
        type:'radio',
        options:[
          {
            id: 'module-2-q-5-a',
            controlName: 'module-2-q-5',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-2-q-5-b',
            controlName: 'module-2-q-5',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-2-q-5-c',
            controlName: 'module-2-q-5',
            required:true,
            value: 'в чем-то согласен, в чем-то нет',
            label: 'в чем-то согласен, в чем-то нет'
          },
          {
            id: 'module-2-q-5-d',
            controlName: 'module-2-q-5',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-2-q-5-e',
            controlName: 'module-2-q-5',
            required:true,
            value: 'абсолютно согласен',
            label: 'абсолютно согласен'
          },
        ]
      },
      {
        title:'6. В будущем я смогу сделать все, что сам захочу.',
        type:'radio',
        options:[
          {
            id: 'module-2-q-6-a',
            controlName: 'module-2-q-6',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-2-q-6-b',
            controlName: 'module-2-q-6',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-2-q-6-c',
            controlName: 'module-2-q-6',
            required:true,
            value: 'в чем-то согласен, в чем-то нет',
            label: 'в чем-то согласен, в чем-то нет'
          },
          {
            id: 'module-2-q-6-d',
            controlName: 'module-2-q-6',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-2-q-6-e',
            controlName: 'module-2-q-6',
            required:true,
            value: 'абсолютно согласен',
            label: 'абсолютно согласен'
          },
        ]
      },
      {
        title:'7. Я думаю, что многие мои мечты вряд ли сбудутся.',
        type:'radio',
        options:[
          {
            id: 'module-2-q-7-a',
            controlName: 'module-2-q-7',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-2-q-7-b',
            controlName: 'module-2-q-7',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-2-q-7-c',
            controlName: 'module-2-q-7',
            required:true,
            value: 'в чем-то согласен, в чем-то нет',
            label: 'в чем-то согласен, в чем-то нет'
          },
          {
            id: 'module-2-q-7-d',
            controlName: 'module-2-q-7',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-2-q-7-e',
            controlName: 'module-2-q-7',
            required:true,
            value: 'абсолютно согласен',
            label: 'абсолютно согласен'
          },
        ]
      },
      {
        title:'8. Я строю планы на жизнь, несмотря на трудности и препятствия.',
        type:'radio',
        options:[
          {
            id: 'module-2-q-8-a',
            controlName: 'module-2-q-8',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-2-q-8-b',
            controlName: 'module-2-q-8',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-2-q-8-c',
            controlName: 'module-2-q-8',
            required:true,
            value: 'в чем-то согласен, в чем-то нет',
            label: 'в чем-то согласен, в чем-то нет'
          },
          {
            id: 'module-2-q-8-d',
            controlName: 'module-2-q-8',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-2-q-8-e',
            controlName: 'module-2-q-8',
            required:true,
            value: 'абсолютно согласен',
            label: 'абсолютно согласен'
          },
        ]
      },
      {
        title:'9. Мне кажется, что большинство окружающих меня людей не ждут от будущего ничего хорошего.',
        type:'radio',
        options:[
          {
            id: 'module-2-q-9-a',
            controlName: 'module-2-q-9',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-2-q-9-b',
            controlName: 'module-2-q-9',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-2-q-9-c',
            controlName: 'module-2-q-9',
            required:true,
            value: 'в чем-то согласен, в чем-то нет',
            label: 'в чем-то согласен, в чем-то нет'
          },
          {
            id: 'module-2-q-9-d',
            controlName: 'module-2-q-9',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-2-q-9-e',
            controlName: 'module-2-q-9',
            required:true,
            value: 'абсолютно согласен',
            label: 'абсолютно согласен'
          },
        ]
      },
      {
        title:'10. Я верю, что в будущем произойдет больше интересных событий, чем в прошлом.',
        type:'radio',
        options:[
          {
            id: 'module-2-q-10-a',
            controlName: 'module-2-q-10',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-2-q-10-b',
            controlName: 'module-2-q-10',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-2-q-10-c',
            controlName: 'module-2-q-10',
            required:true,
            value: 'в чем-то согласен, в чем-то нет',
            label: 'в чем-то согласен, в чем-то нет'
          },
          {
            id: 'module-2-q-10-d',
            controlName: 'module-2-q-10',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-2-q-10-e',
            controlName: 'module-2-q-10',
            required:true,
            value: 'абсолютно согласен',
            label: 'абсолютно согласен'
          },
        ]
      },
      {
        title:'11. Я верю, что большинство людей способны преодолеть препятствия и жизненные трудности.',
        type:'radio',
        options:[
          {
            id: 'module-2-q-11-a',
            controlName: 'module-2-q-11',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-2-q-11-b',
            controlName: 'module-2-q-11',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-2-q-11-c',
            controlName: 'module-2-q-11',
            required:true,
            value: 'в чем-то согласен, в чем-то нет',
            label: 'в чем-то согласен, в чем-то нет'
          },
          {
            id: 'module-2-q-11-d',
            controlName: 'module-2-q-11',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-2-q-11-e',
            controlName: 'module-2-q-11',
            required:true,
            value: 'абсолютно согласен',
            label: 'абсолютно согласен'
          },
        ]
      },
      {
        title:'12. Я беспокоюсь, что в будущем у меня ничего не получится.',
        type:'radio',
        options:[
          {
            id: 'module-2-q-12-a',
            controlName: 'module-2-q-12',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-2-q-12-b',
            controlName: 'module-2-q-12',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-2-q-12-c',
            controlName: 'module-2-q-12',
            required:true,
            value: 'в чем-то согласен, в чем-то нет',
            label: 'в чем-то согласен, в чем-то нет'
          },
          {
            id: 'module-2-q-12-d',
            controlName: 'module-2-q-12',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-2-q-12-e',
            controlName: 'module-2-q-12',
            required:true,
            value: 'абсолютно согласен',
            label: 'абсолютно согласен'
          },
        ]
      },
      {
        title:'13. Мне кажется, что мои близкие продолжают строить планы на будущее.',
        type:'radio',
        options:[
          {
            id: 'module-2-q-13-a',
            controlName: 'module-2-q-13',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-2-q-13-b',
            controlName: 'module-2-q-13',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-2-q-13-c',
            controlName: 'module-2-q-13',
            required:true,
            value: 'в чем-то согласен, в чем-то нет',
            label: 'в чем-то согласен, в чем-то нет'
          },
          {
            id: 'module-2-q-13-d',
            controlName: 'module-2-q-13',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-2-q-13-e',
            controlName: 'module-2-q-13',
            required:true,
            value: 'абсолютно согласен',
            label: 'абсолютно согласен'
          },
        ]
      },
      {
        title:'14. Я замечаю, что у меня меньше планов на будущее, чем было раньше',
        type:'radio',
        options:[
          {
            id: 'module-2-q-14-a',
            controlName: 'module-2-q-14',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-2-q-14-b',
            controlName: 'module-2-q-14',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-2-q-14-c',
            controlName: 'module-2-q-14',
            required:true,
            value: 'в чем-то согласен, в чем-то нет',
            label: 'в чем-то согласен, в чем-то нет'
          },
          {
            id: 'module-2-q-14-d',
            controlName: 'module-2-q-14',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-2-q-14-e',
            controlName: 'module-2-q-14',
            required:true,
            value: 'абсолютно согласен',
            label: 'абсолютно согласен'
          },
        ]
      },
      {
        title:'15. Я чаще задумываюсь о будущем, чем вспоминаю прошлое.',
        type:'radio',
        options:[
          {
            id: 'module-2-q-15-a',
            controlName: 'module-2-q-15',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-2-q-15-b',
            controlName: 'module-2-q-15',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-2-q-15-c',
            controlName: 'module-2-q-15',
            required:true,
            value: 'в чем-то согласен, в чем-то нет',
            label: 'в чем-то согласен, в чем-то нет'
          },
          {
            id: 'module-2-q-15-d',
            controlName: 'module-2-q-15',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-2-q-15-e',
            controlName: 'module-2-q-15',
            required:true,
            value: 'абсолютно согласен',
            label: 'абсолютно согласен'
          },
        ]
      },
      {
        title:'16. Я верю, что в будущем меня ждет много хорошего.',
        type:'radio',
        options:[
          {
            id: 'module-2-q-16-a',
            controlName: 'module-2-q-16',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-2-q-16-b',
            controlName: 'module-2-q-16',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-2-q-16-c',
            controlName: 'module-2-q-16',
            required:true,
            value: 'в чем-то согласен, в чем-то нет',
            label: 'в чем-то согласен, в чем-то нет'
          },
          {
            id: 'module-2-q-16-d',
            controlName: 'module-2-q-16',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-2-q-16-e',
            controlName: 'module-2-q-16',
            required:true,
            value: 'абсолютно согласен',
            label: 'абсолютно согласен'
          },
        ]
      },
    ]
  },
  {
    moduleNumber:3,
    titleModule:'В какой степени Вы согласны со следующими утверждениями? В последние 30 дней...',
    data:[
      {
        title:'1. Я испытывал недостаток общения.',
        type:'radio',
        options:[
          {
            id: 'module-3-q-1-a',
            controlName: 'module-3-q-1',
            required:true,
            value: 'очень редко или никогда',
            label: 'очень редко или никогда'
          },
          {
            id: 'module-3-q-1-b',
            controlName: 'module-3-q-1',
            required:true,
            value: 'время от времени',
            label: 'время от времени'
          },
          {
            id: 'module-3-q-1-c',
            controlName: 'module-3-q-1',
            required:true,
            value: 'часто',
            label: 'часто'
          },
        ]
      },
      {
        title:'2. Я чувствовал себя обделенным вниманием.',
        type:'radio',
        options:[
          {
            id: 'module-3-q-2-a',
            controlName: 'module-3-q-2',
            required:true,
            value: 'очень редко или никогда',
            label: 'очень редко или никогда'
          },
          {
            id: 'module-3-q-2-b',
            controlName: 'module-3-q-2',
            required:true,
            value: 'время от времени',
            label: 'время от времени'
          },
          {
            id: 'module-3-q-2-c',
            controlName: 'module-3-q-2',
            required:true,
            value: 'часто',
            label: 'часто'
          },
        ]
      },
      {
        title:'3. Я ощущал себя в изоляции от других людей.',
        type:'radio',
        options:[
          {
            id: 'module-3-q-3-a',
            controlName: 'module-3-q-3',
            required:true,
            value: 'очень редко или никогда',
            label: 'очень редко или никогда'
          },
          {
            id: 'module-3-q-3-b',
            controlName: 'module-3-q-3',
            required:true,
            value: 'время от времени',
            label: 'время от времени'
          },
          {
            id: 'module-3-q-3-c',
            controlName: 'module-3-q-3',
            required:true,
            value: 'часто',
            label: 'часто'
          },
        ]
      },
      {
        title:'4. Я чувствовал, что люди, которые не находятся в моей ситуации, не могут меня понять.',
        type:'radio',
        options:[
          {
            id: 'module-3-q-4-a',
            controlName: 'module-3-q-4',
            required:true,
            value: 'очень редко или никогда',
            label: 'очень редко или никогда'
          },
          {
            id: 'module-3-q-4-b',
            controlName: 'module-3-q-4',
            required:true,
            value: 'время от времени',
            label: 'время от времени'
          },
          {
            id: 'module-3-q-4-c',
            controlName: 'module-3-q-4',
            required:true,
            value: 'часто',
            label: 'часто'
          },
        ]
      },
    ]
  },
  {
    moduleNumber:4,
    titleModule:'Следующие вопросы имеют отношение к переживанию того, кто Вы есть. Это переживание включает в себя то, как Вы сами описываете себя и то, как другие могут описать Вас.В связи с какими-либо Вашими особенностями, за последние 15 дней ... ',
    data:[
      {
        title:'1. Вы слышали, видели или читали шутки или насмешки в свой адрес (или в адрес похожих на Вас людей)',
        type:'radio',
        options:[
          {
            id: 'module-4-q-1-a',
            controlName: 'module-4-q-1',
            required:true,
            value: 'никогда',
            label: 'никогда'
          },
          {
            id: 'module-4-q-1-b',
            controlName: 'module-4-q-1',
            required:true,
            value: 'да, один или два раза',
            label: 'да, один или два раза'
          },
          {
            id: 'module-4-q-1-c',
            controlName: 'module-4-q-1',
            required:true,
            value: 'да, много раз',
            label: 'да, много раз'
          },
        ]
      },
      {
        title:'2. Вас считали недружелюбным, ненужным или грубым',
        type:'radio',
        options:[
          {
            id: 'module-4-q-2-a',
            controlName: 'module-4-q-2',
            required:true,
            value: 'никогда',
            label: 'никогда'
          },
          {
            id: 'module-4-q-2-b',
            controlName: 'module-4-q-2',
            required:true,
            value: 'да, один или два раза',
            label: 'да, один или два раза'
          },
          {
            id: 'module-4-q-2-c',
            controlName: 'module-4-q-2',
            required:true,
            value: 'да, много раз',
            label: 'да, много раз'
          },
        ]
      },
      {
        title:'3. Вы слышали/видели оскорбительные высказывания по поводу группы, к которой Вы принадлежите, или получали их лично в свой адрес из-за Вашей принадлежности к группе',
        type:'radio',
        options:[
          {
            id: 'module-4-q-3-a',
            controlName: 'module-4-q-3',
            required:true,
            value: 'никогда',
            label: 'никогда'
          },
          {
            id: 'module-4-q-3-b',
            controlName: 'module-4-q-3',
            required:true,
            value: 'да, один или два раза',
            label: 'да, один или два раза'
          },
          {
            id: 'module-4-q-3-c',
            controlName: 'module-4-q-3',
            required:true,
            value: 'да, много раз',
            label: 'да, много раз'
          },
        ]
      },
      {
        title:'4. С Вами вели себя так, как будто Вас боятся',
        type:'radio',
        options:[
          {
            id: 'module-4-q-4-a',
            controlName: 'module-4-q-4',
            required:true,
            value: 'никогда',
            label: 'никогда'
          },
          {
            id: 'module-4-q-4-b',
            controlName: 'module-4-q-4',
            required:true,
            value: 'да, один или два раза',
            label: 'да, один или два раза'
          },
          {
            id: 'module-4-q-4-c',
            controlName: 'module-4-q-4',
            required:true,
            value: 'да, много раз',
            label: 'да, много раз'
          },
        ]
      },
      {
        title:'5. На Вас глазели или указывали на Вас на публике',
        type:'radio',
        options:[
          {
            id: 'module-4-q-5-a',
            controlName: 'module-4-q-5',
            required:true,
            value: 'никогда',
            label: 'никогда'
          },
          {
            id: 'module-4-q-5-b',
            controlName: 'module-4-q-5',
            required:true,
            value: 'да, один или два раза',
            label: 'да, один или два раза'
          },
          {
            id: 'module-4-q-5-c',
            controlName: 'module-4-q-5',
            required:true,
            value: 'да, много раз',
            label: 'да, много раз'
          },
        ]
      },
      {
        title:'6. Вам говорили, что Вы должны думать, вести себя или выглядеть так, как другие',
        type:'radio',
        options:[
          {
            id: 'module-4-q-6-a',
            controlName: 'module-4-q-6',
            required:true,
            value: 'никогда',
            label: 'никогда'
          },
          {
            id: 'module-4-q-6-b',
            controlName: 'module-4-q-6',
            required:true,
            value: 'да, один или два раза',
            label: 'да, один или два раза'
          },
          {
            id: 'module-4-q-6-c',
            controlName: 'module-4-q-6',
            required:true,
            value: 'да, много раз',
            label: 'да, много раз'
          },
        ]
      },
      {
        title:'7. Вы слышали, что Вам или таким людям как Вы, здесь не место',
        type:'radio',
        options:[
          {
            id: 'module-4-q-7-a',
            controlName: 'module-4-q-7',
            required:true,
            value: 'никогда',
            label: 'никогда'
          },
          {
            id: 'module-4-q-7-b',
            controlName: 'module-4-q-7',
            required:true,
            value: 'да, один или два раза',
            label: 'да, один или два раза'
          },
          {
            id: 'module-4-q-7-c',
            controlName: 'module-4-q-7',
            required:true,
            value: 'да, много раз',
            label: 'да, много раз'
          },
        ]
      },
      {
        title:'8. Вам задавали неприемлемые, оскорбительные или чрезмерно личные вопросы',
        type:'radio',
        options:[
          {
            id: 'module-4-q-8-a',
            controlName: 'module-4-q-8',
            required:true,
            value: 'никогда',
            label: 'никогда'
          },
          {
            id: 'module-4-q-8-b',
            controlName: 'module-4-q-8',
            required:true,
            value: 'да, один или два раза',
            label: 'да, один или два раза'
          },
          {
            id: 'module-4-q-8-c',
            controlName: 'module-4-q-8',
            required:true,
            value: 'да, много раз',
            label: 'да, много раз'
          },
        ]
      },

      {
        title:'9. С Вами вели себя так, как будто Вы не такой умный или не такой способный как другие',
        type:'radio',
        options:[
          {
            id: 'module-4-q-9-a',
            controlName: 'module-4-q-9',
            required:true,
            value: 'никогда',
            label: 'никогда'
          },
          {
            id: 'module-4-q-9-b',
            controlName: 'module-4-q-9',
            required:true,
            value: 'да, один или два раза',
            label: 'да, один или два раза'
          },
          {
            id: 'module-4-q-9-c',
            controlName: 'module-4-q-9',
            required:true,
            value: 'да, много раз',
            label: 'да, много раз'
          },
        ]
      },
    ]
  },
  {
    moduleNumber:5,
    titleModule:'Прочитайте утверждения и выберите соответствующий вариант ответа в зависимости от того, как Вы себя чувствовали на протяжении последних семи дней. Нет правильных или неправильных ответов. Не нужно тратить слишком много времени на размышление.',
    data:[
      {
        title:'1. Мне было трудно успокоиться.',
        type:'radio',
        options:[
          {
            id: 'module-5-q-1-a',
            controlName: 'module-5-q-1',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-1-b',
            controlName: 'module-5-q-1',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-1-c',
            controlName: 'module-5-q-1',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-1-d',
            controlName: 'module-5-q-1',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'2. Я чувствовал сухость во рту.',
        type:'radio',
        options:[
          {
            id: 'module-5-q-2-a',
            controlName: 'module-5-q-2',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-2-b',
            controlName: 'module-5-q-2',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-2-c',
            controlName: 'module-5-q-2',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-2-d',
            controlName: 'module-5-q-2',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'3. Кажется, я вообще не был способен испытывать никаких позитивных чувств.',
        type:'radio',
        options:[
          {
            id: 'module-5-q-3-a',
            controlName: 'module-5-q-3',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-3-b',
            controlName: 'module-5-q-3',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-3-c',
            controlName: 'module-5-q-3',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-3-d',
            controlName: 'module-5-q-3',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'4. У меня случались затруднения с дыханием (например, учащенное дыхание, одышка без какой-либо физической нагрузки)',
        type:'radio',
        options:[
          {
            id: 'module-5-q-4-a',
            controlName: 'module-5-q-4',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-4-b',
            controlName: 'module-5-q-4',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-4-c',
            controlName: 'module-5-q-4',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-4-d',
            controlName: 'module-5-q-4',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'5. Мне было сложно заставить себя начать что-либо делать',
        type:'radio',
        options:[
          {
            id: 'module-5-q-5-a',
            controlName: 'module-5-q-5',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-5-b',
            controlName: 'module-5-q-5',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-5-c',
            controlName: 'module-5-q-5',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-5-d',
            controlName: 'module-5-q-5',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'6. Я мог слишком остро реагировать на ситуации.',
        type:'radio',
        options:[
          {
            id: 'module-5-q-6-a',
            controlName: 'module-5-q-6',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-6-b',
            controlName: 'module-5-q-6',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-6-c',
            controlName: 'module-5-q-6',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-6-d',
            controlName: 'module-5-q-6',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'7. Я испытывал дрожь (например, дрожали руки)',
        type:'radio',
        options:[
          {
            id: 'module-5-q-7-a',
            controlName: 'module-5-q-7',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-7-b',
            controlName: 'module-5-q-7',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-7-c',
            controlName: 'module-5-q-7',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-7-d',
            controlName: 'module-5-q-7',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'8. Я чувствовал, что много нервничал',
        type:'radio',
        options:[
          {
            id: 'module-5-q-8-a',
            controlName: 'module-5-q-8',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-8-b',
            controlName: 'module-5-q-8',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-8-c',
            controlName: 'module-5-q-8',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-8-d',
            controlName: 'module-5-q-8',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'9. Меня беспокоили ситуации, в которых я мог запаниковать и выставить себя на посмешище.',
        type:'radio',
        options:[
          {
            id: 'module-5-q-9-a',
            controlName: 'module-5-q-9',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-9-b',
            controlName: 'module-5-q-9',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-9-c',
            controlName: 'module-5-q-9',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-9-d',
            controlName: 'module-5-q-9',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'10. Я чувствовал, что мне не к чему стремиться.',
        type:'radio',
        options:[
          {
            id: 'module-5-q-10-a',
            controlName: 'module-5-q-10',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-10-b',
            controlName: 'module-5-q-10',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-10-c',
            controlName: 'module-5-q-10',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-10-d',
            controlName: 'module-5-q-10',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'11. Я чувствовал себя взвинченным',
        type:'radio',
        options:[
          {
            id: 'module-5-q-11-a',
            controlName: 'module-5-q-11',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-11-b',
            controlName: 'module-5-q-11',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-11-c',
            controlName: 'module-5-q-11',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-11-d',
            controlName: 'module-5-q-11',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'12. Мне было сложно расслабиться.',
        type:'radio',
        options:[
          {
            id: 'module-5-q-12-a',
            controlName: 'module-5-q-12',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-12-b',
            controlName: 'module-5-q-12',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-12-c',
            controlName: 'module-5-q-12',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-12-d',
            controlName: 'module-5-q-12',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'13. Я испытывал тоску и подавленность.',
        type:'radio',
        options:[
          {
            id: 'module-5-q-13-a',
            controlName: 'module-5-q-13',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-13-b',
            controlName: 'module-5-q-13',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-13-c',
            controlName: 'module-5-q-13',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-13-d',
            controlName: 'module-5-q-13',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'14. Меня раздражало все, что мешало моим занятиям и делам.',
        type:'radio',
        options:[
          {
            id: 'module-5-q-14-a',
            controlName: 'module-5-q-14',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-14-b',
            controlName: 'module-5-q-14',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-14-c',
            controlName: 'module-5-q-14',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-14-d',
            controlName: 'module-5-q-14',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'15. Я был на грани паники.',
        type:'radio',
        options:[
          {
            id: 'module-5-q-15-a',
            controlName: 'module-5-q-15',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-15-b',
            controlName: 'module-5-q-15',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-15-c',
            controlName: 'module-5-q-15',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-15-d',
            controlName: 'module-5-q-15',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'16. Меня ничего не могло заинтересовать или увлечь.',
        type:'radio',
        options:[
          {
            id: 'module-5-q-16-a',
            controlName: 'module-5-q-16',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-16-b',
            controlName: 'module-5-q-16',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-16-c',
            controlName: 'module-5-q-16',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-16-d',
            controlName: 'module-5-q-16',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'17. Я чувствовал, что ничего не стою как личность.',
        type:'radio',
        options:[
          {
            id: 'module-5-q-17-a',
            controlName: 'module-5-q-17',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-17-b',
            controlName: 'module-5-q-17',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-17-c',
            controlName: 'module-5-q-17',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-17-d',
            controlName: 'module-5-q-17',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'18. Меня было легко обидеть.',
        type:'radio',
        options:[
          {
            id: 'module-5-q-18-a',
            controlName: 'module-5-q-18',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-18-b',
            controlName: 'module-5-q-18',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-18-c',
            controlName: 'module-5-q-18',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-18-d',
            controlName: 'module-5-q-18',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'19. Я чувствовал проблемы с сердцебиением без какой-либо физической нагрузки (например, усиленное сердцебиение или перебои в сердцебиении).',
        type:'radio',
        options:[
          {
            id: 'module-5-q-19-a',
            controlName: 'module-5-q-19',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-19-b',
            controlName: 'module-5-q-19',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-19-c',
            controlName: 'module-5-q-19',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-19-d',
            controlName: 'module-5-q-19',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'20. Я испытывал беспричинный страх.',
        type:'radio',
        options:[
          {
            id: 'module-5-q-20-a',
            controlName: 'module-5-q-20',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-20-b',
            controlName: 'module-5-q-20',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-20-c',
            controlName: 'module-5-q-20',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-20-d',
            controlName: 'module-5-q-20',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
      {
        title:'21. Жизнь казалась мне бессмысленной.',
        type:'radio',
        options:[
          {
            id: 'module-5-q-21-a',
            controlName: 'module-5-q-21',
            required:true,
            value: 'не имело ко мне отношения',
            label: 'не имело ко мне отношения'
          },
          {
            id: 'module-5-q-21-b',
            controlName: 'module-5-q-21',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось время от времени',
            label: 'было характерно для меня в некоторой степени или случалось время от времени'
          },
          {
            id: 'module-5-q-21-c',
            controlName: 'module-5-q-21',
            required:true,
            value: 'было характерно для меня в некоторой степени или случалось достаточно часто',
            label: 'было характерно для меня в некоторой степени или случалось достаточно часто'
          },
          {
            id: 'module-5-q-21-d',
            controlName: 'module-5-q-21',
            required:true,
            value: 'было очень характерно для меня или длилось большую часть времени',
            label: 'было очень характерно для меня или длилось большую часть времени'
          },
        ]
      },
    ]
  },
  {
    moduleNumber:6,
    titleModule:'Для каждого утверждения выберите и отметьте один из вариантов ответа. ',
    data:[
      {
        title:'1. У меня есть человек, который рядом, когда мне нужно.',
        type:'radio',
        options:[
          {
            id: 'module-6-q-1-a',
            controlName: 'module-6-q-1',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-6-q-1-b',
            controlName: 'module-6-q-1',
            required:true,
            value: 'не согласен',
            label: 'не согласен'
          },
          {
            id: 'module-6-q-1-c',
            controlName: 'module-6-q-1',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-6-q-1-d',
            controlName: 'module-6-q-1',
            required:true,
            value: 'отчасти да, отчасти нет',
            label: 'отчасти да, отчасти нет'
          },
          {
            id: 'module-6-q-1-e',
            controlName: 'module-6-q-1',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-6-q-1-f',
            controlName: 'module-6-q-1',
            required:true,
            value: 'согласен',
            label: 'согласен'
          },
          {
            id: 'module-6-q-1-g',
            controlName: 'module-6-q-1',
            required:true,
            value: 'совершенно согласен',
            label: 'совершенно согласен'
          },
        ]
      },
      {
        title:'2. У меня есть человек, с которым я могу разделить радость и горе.',
        type:'radio',
        options:[
          {
            id: 'module-6-q-2-a',
            controlName: 'module-6-q-2',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-6-q-2-b',
            controlName: 'module-6-q-2',
            required:true,
            value: 'не согласен',
            label: 'не согласен'
          },
          {
            id: 'module-6-q-2-c',
            controlName: 'module-6-q-2',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-6-q-2-d',
            controlName: 'module-6-q-2',
            required:true,
            value: 'отчасти да, отчасти нет',
            label: 'отчасти да, отчасти нет'
          },
          {
            id: 'module-6-q-2-e',
            controlName: 'module-6-q-2',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-6-q-2-f',
            controlName: 'module-6-q-2',
            required:true,
            value: 'согласен',
            label: 'согласен'
          },
          {
            id: 'module-6-q-2-g',
            controlName: 'module-6-q-2',
            required:true,
            value: 'совершенно согласен',
            label: 'совершенно согласен'
          },
        ]
      },
      {
        title:'3. Моя семья действительно пытается мне помогать.',
        type:'radio',
        options:[
          {
            id: 'module-6-q-3-a',
            controlName: 'module-6-q-3',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-6-q-3-b',
            controlName: 'module-6-q-3',
            required:true,
            value: 'не согласен',
            label: 'не согласен'
          },
          {
            id: 'module-6-q-3-c',
            controlName: 'module-6-q-3',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-6-q-3-d',
            controlName: 'module-6-q-3',
            required:true,
            value: 'отчасти да, отчасти нет',
            label: 'отчасти да, отчасти нет'
          },
          {
            id: 'module-6-q-3-e',
            controlName: 'module-6-q-3',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-6-q-3-f',
            controlName: 'module-6-q-3',
            required:true,
            value: 'согласен',
            label: 'согласен'
          },
          {
            id: 'module-6-q-3-g',
            controlName: 'module-6-q-3',
            required:true,
            value: 'совершенно согласен',
            label: 'совершенно согласен'
          },
        ]
      },
      {
        title:'4. Моя семья оказывает необходимую мне эмоциональную помощь и поддержку.',
        type:'radio',
        options:[
          {
            id: 'module-6-q-4-a',
            controlName: 'module-6-q-4',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-6-q-4-b',
            controlName: 'module-6-q-4',
            required:true,
            value: 'не согласен',
            label: 'не согласен'
          },
          {
            id: 'module-6-q-4-c',
            controlName: 'module-6-q-4',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-6-q-4-d',
            controlName: 'module-6-q-4',
            required:true,
            value: 'отчасти да, отчасти нет',
            label: 'отчасти да, отчасти нет'
          },
          {
            id: 'module-6-q-4-e',
            controlName: 'module-6-q-4',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-6-q-4-f',
            controlName: 'module-6-q-4',
            required:true,
            value: 'согласен',
            label: 'согласен'
          },
          {
            id: 'module-6-q-4-g',
            controlName: 'module-6-q-4',
            required:true,
            value: 'совершенно согласен',
            label: 'совершенно согласен'
          },
        ]
      },
      {
        title:'5. У меня есть человек, с которым мне комфортно.',
        type:'radio',
        options:[
          {
            id: 'module-6-q-5-a',
            controlName: 'module-6-q-5',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-6-q-5-b',
            controlName: 'module-6-q-5',
            required:true,
            value: 'не согласен',
            label: 'не согласен'
          },
          {
            id: 'module-6-q-5-c',
            controlName: 'module-6-q-5',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-6-q-5-d',
            controlName: 'module-6-q-5',
            required:true,
            value: 'отчасти да, отчасти нет',
            label: 'отчасти да, отчасти нет'
          },
          {
            id: 'module-6-q-5-e',
            controlName: 'module-6-q-5',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-6-q-5-f',
            controlName: 'module-6-q-5',
            required:true,
            value: 'согласен',
            label: 'согласен'
          },
          {
            id: 'module-6-q-5-g',
            controlName: 'module-6-q-5',
            required:true,
            value: 'совершенно согласен',
            label: 'совершенно согласен'
          },
        ]
      },
      {
        title:'6. Мои друзья действительно пытаются мне помогать.',
        type:'radio',
        options:[
          {
            id: 'module-6-q-6-a',
            controlName: 'module-6-q-6',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-6-q-6-b',
            controlName: 'module-6-q-6',
            required:true,
            value: 'не согласен',
            label: 'не согласен'
          },
          {
            id: 'module-6-q-6-c',
            controlName: 'module-6-q-6',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-6-q-6-d',
            controlName: 'module-6-q-6',
            required:true,
            value: 'отчасти да, отчасти нет',
            label: 'отчасти да, отчасти нет'
          },
          {
            id: 'module-6-q-6-e',
            controlName: 'module-6-q-6',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-6-q-6-f',
            controlName: 'module-6-q-6',
            required:true,
            value: 'согласен',
            label: 'согласен'
          },
          {
            id: 'module-6-q-6-g',
            controlName: 'module-6-q-6',
            required:true,
            value: 'совершенно согласен',
            label: 'совершенно согласен'
          },
        ]
      },
      {
        title:'7. Я могу рассчитывать на моих друзей, когда что-то идёт не так.',
        type:'radio',
        options:[
          {
            id: 'module-6-q-7-a',
            controlName: 'module-6-q-7',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-6-q-7-b',
            controlName: 'module-6-q-7',
            required:true,
            value: 'не согласен',
            label: 'не согласен'
          },
          {
            id: 'module-6-q-7-c',
            controlName: 'module-6-q-7',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-6-q-7-d',
            controlName: 'module-6-q-7',
            required:true,
            value: 'отчасти да, отчасти нет',
            label: 'отчасти да, отчасти нет'
          },
          {
            id: 'module-6-q-7-e',
            controlName: 'module-6-q-7',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-6-q-7-f',
            controlName: 'module-6-q-7',
            required:true,
            value: 'согласен',
            label: 'согласен'
          },
          {
            id: 'module-6-q-7-g',
            controlName: 'module-6-q-7',
            required:true,
            value: 'совершенно согласен',
            label: 'совершенно согласен'
          },
        ]
      },
      {
        title:'8. Я могу обсуждать свои проблемы в семье.',
        type:'radio',
        options:[
          {
            id: 'module-6-q-8-a',
            controlName: 'module-6-q-8',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-6-q-8-b',
            controlName: 'module-6-q-8',
            required:true,
            value: 'не согласен',
            label: 'не согласен'
          },
          {
            id: 'module-6-q-8-c',
            controlName: 'module-6-q-8',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-6-q-8-d',
            controlName: 'module-6-q-8',
            required:true,
            value: 'отчасти да, отчасти нет',
            label: 'отчасти да, отчасти нет'
          },
          {
            id: 'module-6-q-8-e',
            controlName: 'module-6-q-8',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-6-q-8-f',
            controlName: 'module-6-q-8',
            required:true,
            value: 'согласен',
            label: 'согласен'
          },
          {
            id: 'module-6-q-8-g',
            controlName: 'module-6-q-8',
            required:true,
            value: 'совершенно согласен',
            label: 'совершенно согласен'
          },
        ]
      },
      {
        title:'9. У меня есть друзья, с которыми я могу разделить радость и горе.',
        type:'radio',
        options:[
          {
            id: 'module-6-q-9-a',
            controlName: 'module-6-q-9',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-6-q-9-b',
            controlName: 'module-6-q-9',
            required:true,
            value: 'не согласен',
            label: 'не согласен'
          },
          {
            id: 'module-6-q-9-c',
            controlName: 'module-6-q-9',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-6-q-9-d',
            controlName: 'module-6-q-9',
            required:true,
            value: 'отчасти да, отчасти нет',
            label: 'отчасти да, отчасти нет'
          },
          {
            id: 'module-6-q-9-e',
            controlName: 'module-6-q-9',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-6-q-9-f',
            controlName: 'module-6-q-9',
            required:true,
            value: 'согласен',
            label: 'согласен'
          },
          {
            id: 'module-6-q-9-g',
            controlName: 'module-6-q-9',
            required:true,
            value: 'совершенно согласен',
            label: 'совершенно согласен'
          },
        ]
      },
      {
        title:'10. У меня есть человек, которого волнуют мои переживания.',
        type:'radio',
        options:[
          {
            id: 'module-6-q-10-a',
            controlName: 'module-6-q-10',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-6-q-10-b',
            controlName: 'module-6-q-10',
            required:true,
            value: 'не согласен',
            label: 'не согласен'
          },
          {
            id: 'module-6-q-10-c',
            controlName: 'module-6-q-10',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-6-q-10-d',
            controlName: 'module-6-q-10',
            required:true,
            value: 'отчасти да, отчасти нет',
            label: 'отчасти да, отчасти нет'
          },
          {
            id: 'module-6-q-10-e',
            controlName: 'module-6-q-10',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-6-q-10-f',
            controlName: 'module-6-q-10',
            required:true,
            value: 'согласен',
            label: 'согласен'
          },
          {
            id: 'module-6-q-10-g',
            controlName: 'module-6-q-10',
            required:true,
            value: 'совершенно согласен',
            label: 'совершенно согласен'
          },
        ]
      },
      {
        title:'11. Моя семья готова помочь мне в принятии решений.',
        type:'radio',
        options:[
          {
            id: 'module-6-q-11-a',
            controlName: 'module-6-q-11',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-6-q-11-b',
            controlName: 'module-6-q-11',
            required:true,
            value: 'не согласен',
            label: 'не согласен'
          },
          {
            id: 'module-6-q-11-c',
            controlName: 'module-6-q-11',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-6-q-11-d',
            controlName: 'module-6-q-11',
            required:true,
            value: 'отчасти да, отчасти нет',
            label: 'отчасти да, отчасти нет'
          },
          {
            id: 'module-6-q-11-e',
            controlName: 'module-6-q-11',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-6-q-11-f',
            controlName: 'module-6-q-11',
            required:true,
            value: 'согласен',
            label: 'согласен'
          },
          {
            id: 'module-6-q-11-g',
            controlName: 'module-6-q-11',
            required:true,
            value: 'совершенно согласен',
            label: 'совершенно согласен'
          },
        ]
      },
      {
        title:'12. Я могу обсуждать свои проблемы с друзьями.',
        type:'radio',
        options:[
          {
            id: 'module-6-q-12-a',
            controlName: 'module-6-q-12',
            required:true,
            value: 'абсолютно не согласен',
            label: 'абсолютно не согласен'
          },
          {
            id: 'module-6-q-12-b',
            controlName: 'module-6-q-12',
            required:true,
            value: 'не согласен',
            label: 'не согласен'
          },
          {
            id: 'module-6-q-12-c',
            controlName: 'module-6-q-12',
            required:true,
            value: 'скорее не согласен',
            label: 'скорее не согласен'
          },
          {
            id: 'module-6-q-12-d',
            controlName: 'module-6-q-12',
            required:true,
            value: 'отчасти да, отчасти нет',
            label: 'отчасти да, отчасти нет'
          },
          {
            id: 'module-6-q-12-e',
            controlName: 'module-6-q-12',
            required:true,
            value: 'скорее согласен',
            label: 'скорее согласен'
          },
          {
            id: 'module-6-q-12-f',
            controlName: 'module-6-q-12',
            required:true,
            value: 'согласен',
            label: 'согласен'
          },
          {
            id: 'module-6-q-12-g',
            controlName: 'module-6-q-12',
            required:true,
            value: 'совершенно согласен',
            label: 'совершенно согласен'
          },
        ]
      },
    ]
  }
]
